import { observer } from 'mobx-react';

import { useStores } from '../../../../stores/useStores';
import { DailyMissionTimer } from '../DailyMissionTimer';

import { DailyMissionProgressBarContent } from './DailyMissionProgressBarContent/DailyMissionProgressBarContent';

function DailyMissionProgressBarV2Component() {
  const { dailyMissionsStore } = useStores();
  const { currentDailyMission } = dailyMissionsStore;

  if (!currentDailyMission || !['ACTIVE', 'COMPLETED'].includes(currentDailyMission.status)) {
    return null;
  }

  const timer =
    currentDailyMission.status === 'ACTIVE' ? (
      <DailyMissionTimer dataTestId="dailyMission-progressBar-timer" />
    ) : undefined;

  return <DailyMissionProgressBarContent currentDailyMission={currentDailyMission} timer={timer} />;
}

export const DailyMissionProgressBarV2 = observer(DailyMissionProgressBarV2Component);
